import { render, staticRenderFns } from "./AbbvieFooter.vue?vue&type=template&id=3a5e3f26&scoped=true"
import script from "./AbbvieFooter.vue?vue&type=script&lang=js"
export * from "./AbbvieFooter.vue?vue&type=script&lang=js"
import style0 from "./AbbvieFooter.vue?vue&type=style&index=0&id=3a5e3f26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5e3f26",
  null
  
)

export default component.exports